module.exports = __webpack_public_path__ + "fr_FR-header-5ae92b.webp";